export default function SectionPage({ title, intro, sections = [] }) {
  return (
    <div className="page">
      <section className="hero hero--compact">
        <div className="hero-inner">
          <p className="eyebrow">Recycla Chile</p>
          <h1>{title}</h1>
          <p className="hero-lead">{intro}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="content-wrap">
          {sections.map((section) => (
            <article key={section.title} id={section.id} className="content-card">
              <h2>{section.title}</h2>
              {section.body}
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
